module.exports = __webpack_public_path__ + "img/GTE.3d013b41.svg";